import { createFileRoute, redirect } from '@tanstack/react-router';
import { AGGREGATE_NAMES } from 'cpool-constants';
import { schemaTemplateResolver_ListByDivision } from 'cpool-tables/backend-resolvers';

import { ROLES } from '~/constants.ts';
import { authoriseUser } from '~/features/auth/utils/authoriseUser.ts';
import { getQueryOptions } from '~/queryUtils/getQueryOptions.ts';
import { useUserStore } from '~/store/userStore.ts';

const divisionTemplatesQueryOptions = (divisionId: string | null) => {
    return getQueryOptions({
        aggregateName: AGGREGATE_NAMES.TEMPLATE,
        resolverName: 'listByDivision',
        schema: schemaTemplateResolver_ListByDivision,
        searchParams: {
            divisionId,
        },
    });
};

export const Route = createFileRoute('/_app/management/templates/division')({
    beforeLoad: ({ location }) => authoriseUser([ROLES.division_leader], location),
    loader: async ({ context, location }) => {
        const { user } = useUserStore.getState();
        if (!user) {
            throw redirect({ search: { redirect: location.href }, to: '/login' });
        }
        await context.queryClient.ensureQueryData(divisionTemplatesQueryOptions(user.divisionId ?? null));
    },
});
